import React, { ReactNode, useCallback, useMemo, useState } from 'react'

import {
  COLLAPSED_NAV_WIDTH,
  EXPANDED_NAV_WIDTH,
  NavContext,
} from 'features/project/partials/project-layout/contexts/use-nav'

export const NavProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [isMainNavCollapsed, setIsMainNavCollapsed] = useState(false)
  const mainNavWidth = isMainNavCollapsed
    ? COLLAPSED_NAV_WIDTH
    : EXPANDED_NAV_WIDTH

  const [hasNestedSidebar, setHasNestedSidebar] = useState<boolean>(false)
  const [isNestedSidebarOpen, setIsNestedSidebarOpen] = useState(false)

  const [portalContainer, setPortalContainer] = useState<HTMLDivElement | null>(
    null,
  )

  const toggleMainNav = useCallback(() => {
    setIsMainNavCollapsed((prev) => !prev)
  }, [])

  const toggleNestedSidebar = useCallback(() => {
    setIsNestedSidebarOpen((prev) => !prev)
  }, [])

  const value = useMemo(
    () => ({
      isMainNavCollapsed,
      setIsMainNavCollapsed,
      toggleMainNav,
      mainNavWidth,
      hasNestedSidebar,
      setHasNestedSidebar,
      isNestedSidebarOpen,
      setIsNestedSidebarOpen,
      toggleNestedSidebar,
      portalContainer,
      setPortalContainer,
    }),
    [
      isMainNavCollapsed,
      mainNavWidth,
      hasNestedSidebar,
      isNestedSidebarOpen,
      portalContainer,
      toggleMainNav,
      toggleNestedSidebar,
    ],
  )

  return <NavContext.Provider value={value}>{children}</NavContext.Provider>
}
